import { render } from "./CPOReport.vue?vue&type=template&id=66df40bf&scoped=true"
import script from "./CPOReport.vue?vue&type=script&lang=js"
export * from "./CPOReport.vue?vue&type=script&lang=js"

import "./CPOReport.vue?vue&type=style&index=0&id=66df40bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66df40bf"]])

export default __exports__